export default {
    byNewsItem(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('newsItemId', id).get()
            )
        )
    }
}
